// extracted by mini-css-extract-plugin
export default {"dialog":"src-client-modal-components-Modal-___default__dialog___gdCGZ","paper":"src-client-modal-components-Modal-___default__paper___YCXij"};